module.exports = "https://cdn-b2c.dom.ru/b2c-domru/2.357.4/frontend/_next/static/images/image-3-a363a7c5f930480f05072129d3621217.png";